
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.23724 17.5C3.81631 16.5 3.50005 13.5 4.50005 11C6.14374 6.89077 13.8382 3.5695 20.7821 2.04725C20.8665 2.02873 20.9331 2.1177 20.8909 2.19316C18.9126 5.73111 16.5348 11.9653 13.0001 15.5C9.40005 19.1 6.65818 18.5 5.23724 17.5ZM5.23724 17.5C5.23724 17.5 9.00005 11 15.5001 6.5M5.23724 17.5C4 19.5 3.5 20.5 2.5 23","stroke":"green","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    